import en from './en.json';

export const localeMessages = {
    en: en,
};
